import { render, staticRenderFns } from "./CustomerTabs.vue?vue&type=template&id=1df696a7&scoped=true&"
import script from "./CustomerTabs.vue?vue&type=script&lang=js&"
export * from "./CustomerTabs.vue?vue&type=script&lang=js&"
import style0 from "./CustomerTabs.vue?vue&type=style&index=0&id=1df696a7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df696a7",
  null
  
)

export default component.exports